/**
 * Cookie configuration for the MuniFocus marketing site.
 *
 * Cookie names include a prefix from the `VITE_COOKIE_PREFIX` environment
 * variable so multiple worktrees can run simultaneously on localhost without
 * clobbering each other's cookies.
 *
 *   Production: VITE_COOKIE_PREFIX=munifocus  → `munifocus_web_language`
 *   Worktree 2: VITE_COOKIE_PREFIX=munifocus2 → `munifocus2_web_language`
 */

/** Cookie prefix from the environment, defaulting to `munifocus`. */
export const COOKIE_PREFIX = import.meta.env.VITE_COOKIE_PREFIX || 'munifocus';

/** All client-set cookie names — prefixed for worktree isolation. */
export const COOKIE_NAMES = {
  /** Cookie-consent preferences (JSON). */
  CONSENT: `${COOKIE_PREFIX}_web_cookie_consent`,
  /** Language preference (`en` | `fr`). */
  LANGUAGE: `${COOKIE_PREFIX}_web_language`,
} as const;
